import { createStore } from 'vuex'

export default createStore({
  state: {

    // ip: 'localhost:3000',
    ip:'binjia.forgex.cn:3000',
    // ip:'yangxuan.forgex.cn:9000',
    // ip:'forgex.cn:2000',

    //本地调试记得打开vue.config.js中的proxy  gpt



    mail: "miller@bin-jia.cn,jeffrey@bin-jia.cn",
    // mail:"skyfall@iskyfall.com",
    maskshow: false,
    updateSystem: false,
    ws: false,

    avoidKey: ['billmoney', 'billapplyer', 'status', 'newTime', 'papplyer', 'pchecktime', 'tprice',
      'ctnsgw', 'ctnsnw', 'ctnv', 'ctnsv', 'inctn', 'factorytp', 'portctns', 'portv', 'lastedit', 'uploader', 'time'
    ],
    timeKey: ['clienttime', 'portordertime', 'portloadtime', 'factorytime', 'etd', 'eta'],

  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
